import { render } from "./Main.vue?vue&type=template&id=2e8a23c9"
const script = {}

import exportComponent from "/var/www/kosamba-new-moover/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__